import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/tick-icon.png';
const _withScopeId = (n) => (_pushScopeId("data-v-c73c17d4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "thankYouContainer" };
const _hoisted_2 = { class: "thankYouBlock" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: "thank you"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h3", null, "Thank you!", -1));
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = {
    key: 0,
    class: "btm-content"
};
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Do you want to take the vehicle to the garage?", -1));
import { computed, ref } from "vue";
import DButton from "../components/button/SubmitButton.vue";
import { useStore } from "vuex";
import { TowVehicleServiceBookingStatus } from "../interfaces/main-data";
// import BottomSheet from "../components/bottomSheet/BottomSheet.vue";
import BottomSheetGarage from "../components/bottomSheetGarage/BottomSheetGarage.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ThankYou',
    emits: ["close", "onPickUpStart", "update:value"],
    setup(__props, { emit: __emit }) {
        // The name is implicitly the file name, or you can set it directly in the setup script with the 'name' option if needed.
        const spanVisible = ref(false);
        const sumbitData = ref();
        const store = useStore();
        // const emit = defineEmits(["close", "onPickUpStart"]);
        const emit = __emit;
        const towVehicleStatus = computed(() => store.getters.towVehicleStatus);
        const onPickUpStart = () => {
            console.log("hello 1234", sumbitData.value?.serviceCenter?.title, sumbitData.value?.note);
            emit("onPickUpStart");
            // emit("update:value", sumbitData.value);
            emit("update:value", {
                serviceCenter: sumbitData.value?.serviceCenter?._id,
                note: sumbitData.value?.note,
            });
        };
        const toggle = () => {
            spanVisible.value = !spanVisible.value;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _hoisted_4,
                    (towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).ARRIVED)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, " The On-Road Assistance task has been successfully completed "))
                        : _createCommentVNode("", true),
                    (towVehicleStatus.value !== _unref(TowVehicleServiceBookingStatus).ARRIVED)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, " The Tow to service center task has been completed successfully. "))
                        : _createCommentVNode("", true)
                ]),
                (towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).ARRIVED)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _hoisted_8,
                        _createVNode(DButton, {
                            link: "",
                            value: "Tow to service center",
                            onClick: toggle
                        })
                    ]))
                    : _createCommentVNode("", true),
                (spanVisible.value)
                    ? (_openBlock(), _createBlock(BottomSheetGarage, {
                        key: 1,
                        value: "Are you sure you want to take the vehicle to the garage?",
                        onClose: toggle,
                        onStart: onPickUpStart,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event) => ((sumbitData).value = $event))
                    }, null, 8, ["value"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
